/**
 * Calculates the approximate circumference of an ellipse using Ramanujan's approximation
 * https://en.wikipedia.org/wiki/Ellipse#Circumference
 */
import { roundTo } from '@/utils';

export function getEllipseCircumference(
  rx: number,
  ry: number
): number {
  const a = Math.max(rx, ry);
  const b = Math.min(rx, ry);
  const h = Math.pow(a - b, 2) / Math.pow(a + b, 2);

  return (
    Math.PI * (a + b) * (1 + (3 * h) / (10 + Math.sqrt(4 - 3 * h)))
  );
}

export function getSymmetricalPolygonPoints(
  numOfSides: number,
  cx: number,
  cy: number,
  r: number
) {
  return Array.from({ length: numOfSides }, (_, i) => {
    // For even-sided polygons, rotate by half the angle between vertices
    const rotationOffset =
      numOfSides % 2 === 0 ? Math.PI / numOfSides : 0;
    const angle =
      (i * 2 * Math.PI) / numOfSides - Math.PI / 2 + rotationOffset;
    const x = roundTo(cx + r * Math.cos(angle), 2);
    const y = roundTo(cy + r * Math.sin(angle), 2);

    return `${x},${y}`;
  }).join(' ');
}
